module.exports = __webpack_public_path__ + "img/sec1_box3.1e514c17.jpg";